/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface WithNoSignup
 */
export interface WithNoSignupOptional {
  /**
   *
   * @type {boolean}
   * @memberof WithNoSignup
   */
  noSignup?: boolean;
}

export interface WithNoSignup extends WithNoSignupOptional {
  /**
   *
   * @type {boolean}
   * @memberof WithNoSignup
   */
  noSignup?: boolean;
}

export interface WithNoSignupTrackedI {
  /**
   *
   * @type {boolean}
   * @memberof WithNoSignup
   */
  noSignup?: boolean;
  noSignupIsSet: boolean;
}

transformDatesMap.set("WithNoSignup", function (model: WithNoSignup) {});

export type WithNoSignupMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  noSignup: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var WithNoSignupMeta: WithNoSignupMetaI = {} as WithNoSignupMetaI;
WithNoSignupMeta = typeMeta("WithNoSignup", {
  noSignup: propertyMeta(
    "noSignup",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = WithNoSignupMeta;

registerMeta(() => {});

export class WithNoSignupTracked implements WithNoSignupTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  noSignup__I?: boolean = undefined;
  noSignupIsSet: boolean = false;
  set noSignup(v: undefined | boolean) {
    if (v !== undefined) {
      this.noSignup__I = v;
      this.noSignupIsSet = true;
    } else {
      this.noSignup__I = v || undefined;
      this.noSignupIsSet = false;
    }
    this.changeTracker = true;
  }
  get noSignup() {
    return this.noSignup__I;
  }
  constructor(config?: WithNoSignupOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: WithNoSignupOptional,
    options?: AssignOptions,
  ): WithNoSignupTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.noSignup && this.noSignupApplyFilter(optionsRequired.filter)) {
      this.noSignup = config.noSignup;
      if (optionsRequired.unassign) this.noSignupIsSet = false;
      else this.noSignupIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithNoSignupTrackedI {
    const cloned = {} as WithNoSignupTrackedI;
    if (
      this.noSignupIsSetDeep() &&
      this.noSignupApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.noSignupIsSet = true;
      cloned.noSignup = this.noSignup;
    } else {
      //cloned.noSignupIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithNoSignupTrackedI {
    if (!this.noSignupApplyFilter(filter)) this.noSignupIsSet = false;

    return this;
  }
  noSignupApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WithNoSignupMeta.noSignup,
      WithNoSignupMeta,
      this.noSignup,
      this,
    );
  }
  noSignupIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.noSignupIsSet && this.noSignupApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.noSignupIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
